/* eslint-disable */
import  axios from 'axios'
import vm from '../main'

var qs = require("qs");
// import Vue from 'vue'

//const PRODUCT_URL = 'https://api.daoway.cn/daoway/rest'
 //const MOCK_URL = 'https://api.daoway.cn/daoway/rest'
let http = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? PRODUCT_URL : MOCK_URL
 })
// 请求拦截器
http.interceptors.request.use(
  config => {
    // 设置token，Content-Type
    //var token = sessionStorage.getItem('UserLoginToken')
    // var token = localStorage.getItem("token") || utils.getCookie("token");
    // if(token){
    //   config.headers['cookie'] = 'token='+token
    // }
    //config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    //config.data = qs.stringify(config.data);
    //console.log(config.data)
    config.headers['client'] = "DWBM"
    // 请求显示loading效果
    // if (config.loading === true) {
    //   vm.$loading.show()
    // }
    return config
  },
  error => {
    //vm.$loading.hide()
    return Promise.reject(error)
  }
)
// 响应拦截器
http.interceptors.response.use(
  res => {
   // vm.$loading.hide()
    // token失效，重新登录
    if (res.data.status == "error") {
      // router.replace({
      //   path: '/login' // 到登录页重新获取token
      // })
      //重新登录
    }
    return res
  },
  error => {
    //vm.$loading.hide()
    return Promise.reject(error)
  }
)

function get (url, data, lodaing) {
  return new Promise((resolve, reject) => {
    http.get(url)
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

function post (url, data, async) {
  return new Promise((resolve, reject) => {
    http.post(url, data, { async: async })
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

function put (url, data, async) {
  return new Promise((resolve, reject) => {
    http.put(url, data, { async: async })
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

function DELETE(url, data, lodaing) {
  return new Promise((resolve, reject) => {
    http.delete(url)
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

export default{get, post, put, DELETE}



// WEBPACK FOOTER //
// ./src/JS/ajax.js